// src/components/Register.js
import React, { useState } from "react";
import { register } from "../../utils/auth";
import Select from "react-select";
import cc from "currency-codes";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Loader from "../OtherComponents/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const countries = cc.countries().map((name) => ({
  value: name,
  label: name,
}));

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    country: null,
    password: "",
    confirmPassword: "",
    address: "",
    city: "",
    state: "",
    phoneNumber: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const {
    firstName,
    lastName,
    email,
    country,
    password,
    confirmPassword,
    address,
    city,
    state,
    phoneNumber,
  } = formData;
  const navigate = useNavigate();

  const onChange = (e) => {
    setErrors({ ...errors, [e.target.name]: "" });
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCountryChange = (selectedOption) => {
    setFormData({ ...formData, country: selectedOption });
  };

  const validate = () => {
    const errors = {};
    if (!firstName) {
      errors.firstName = "First name is required";
    }
    if (!lastName) {
      errors.lastName = "Last name is required";
    }
    if (!country) {
      errors.country = "Country is required";
    }
    if (!email) {
      errors.email = "Email is required";
    }
    if (!address) {
      errors.address = "Address is required";
    }
    if (!city) {
      errors.city = "City is required";
    }
    if (!state) {
      errors.state = "State is required";
    }
    if (!phoneNumber) {
      errors.phoneNumber = "Phone number is required";
    } else if (!/^\+?\d+$/.test(phoneNumber) || phoneNumber.indexOf("+") > 0) {
      errors.phoneNumber = "Phone number must contain only numbers.";
      toast.error("Phone number must contain only numbers.", {
        autoClose: 2000,
      });
    }
    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }
    if (password !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    return errors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        setLoading(true);
        formData.country = formData.country.value;
        await register(formData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);

        setTimeout(() => {
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            country: null,
            password: "",
            confirmPassword: "",
            address: "",
            city: "",
            state: "",
            phoneNumber: "",
          });
          setErrors({});
          navigate("/thanks", { state: { show: true, page: "register" } });
        }, 1000);
      } catch (err) {
        console.error(err.response.data);
        setTimeout(() => {
          setErrors({ server: err.response.data.msg });
          toast.error(err.response.data.msg);
          setLoading(false);
        }, 1000);
      }
    }
  };

  return (
    <>
      <Header />
      <ToastContainer />
      <div className="topHeading">
        <h2>Register</h2>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="form-content">
          <form onSubmit={onSubmit} className="my-form">
            <div className="form-content-inner">
              <div className="inner-div">
                <input
                  type="text"
                  name="firstName"
                  value={firstName}
                  onChange={onChange}
                  placeholder="First Name"
                  required
                />
                {errors.firstName && (
                  <p className="error">{errors.firstName}</p>
                )}
              </div>
              <div className="inner-div">
                <input
                  type="text"
                  name="lastName"
                  value={lastName}
                  onChange={onChange}
                  placeholder="Last Name"
                  required
                />
                {errors.lastName && <p className="error">{errors.lastName}</p>}
              </div>
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={onChange}
              placeholder="Email"
              required
            />
            {errors.email && <p className="error">{errors.email}</p>}
            <div className="inner-div password-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Password"
                required
              />
              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle-icon"
              />
              {errors.password && <p className="error">{errors.password}</p>}
            </div>
            <div className="inner-div password-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={confirmPassword}
                onChange={onChange}
                placeholder="Confirm Password"
                required
              />
              <FontAwesomeIcon
                icon={showConfirmPassword ? faEyeSlash : faEye}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="password-toggle-icon"
              />
              {errors.confirmPassword && (
                <p className="error">{errors.confirmPassword}</p>
              )}
            </div>

            <Select
              options={countries}
              value={country}
              onChange={handleCountryChange}
              placeholder="Select Country"
              className="selectCountry"
              required
            />
            {errors.country && <p className="error">{errors.country}</p>}

            <textarea
              name="address"
              value={address}
              className="textAddressArea"
              onChange={onChange}
              rows={4}
              placeholder="Address"
              required
            />

            {errors.address && <p className="error">{errors.address}</p>}

            <div className="form-content-inner">
              <div className="inner-div">
                <input
                  type="text"
                  name="city"
                  value={city}
                  onChange={onChange}
                  placeholder="City"
                  required
                />
                {errors.city && <p className="error">{errors.city}</p>}
              </div>
              <div className="inner-div">
                <input
                  type="text"
                  name="state"
                  value={state}
                  onChange={onChange}
                  placeholder="State"
                  required
                />
                {errors.state && <p className="error">{errors.state}</p>}
              </div>
            </div>

            <input
              type="text"
              name="phoneNumber"
              value={phoneNumber}
              onChange={onChange}
              placeholder="Phone Number"
              required
            />
            {errors.phoneNumber && (
              <p className="error">{errors.phoneNumber}</p>
            )}

            <button type="submit">{!loading && "Register"}</button>
            {errors.server && <p className="error">{errors.server}</p>}
            <p>
              {" "}
              Already have an account{" "}
              <a
                href="/login"
                onClick={() => {
                  setFormData({});
                }}
              >
                Login
              </a>{" "}
            </p>
          </form>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Register;
